import { useState } from "react";
import { IconCopy, IconCheck } from "@tabler/icons-react";

function CopyButton({ text }: { text: string }) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async (textToCopy: string) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // reset icon after 2s
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };

  return (
    <button
      className="text-[#212121]"
      onClick={(e) => {
        e.stopPropagation();
        copyToClipboard(text);
      }}
    >
      {copied ? <IconCheck className="text-green-600" /> : <IconCopy />}
    </button>
  );
}

export default CopyButton;
